import { render } from "./clients_list.vue?vue&type=template&id=6a5ce6b6&scoped=true"
import script from "./clients_list.vue?vue&type=script&lang=js"
export * from "./clients_list.vue?vue&type=script&lang=js"

import "./clients_list.vue?vue&type=style&index=0&id=6a5ce6b6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5ce6b6"]])

export default __exports__